/* Queries */
import { sbRespCollectionsRoot } from '../../queries/sbRespCollectionsRoot';

/* Reducers */
import { defaultReducers } from '../../reducers/reducerUtils';
import { sbSharedReducers } from '../../reducers/sbSharedReducers';
import { sbRespNotificationsReducer as sharedNotificationsReducer } from '../../reducers/sbRespNotificationsReducer';

/* Components */
import { SbRespCollectionsLayout } from '../../finding/SbRespCollectionsLayout/SbRespCollectionsLayout';

/* Helpers */
import { createEntry } from '../createEntry';
import { initializeDBL } from 'dibs-buyer-layout/src/entries';
import SV from 'server-vars';

/* Notifications */
import { sbRespNotifications } from '../../finding/SbRespNotifications/sbRespNotifications';

/**
 * DBL has a different environment that's created in initializeDBL.
 */
const options = {
    notifications: sbRespNotifications,
    reducers: {
        ...defaultReducers,
        ...sbSharedReducers,
        sharedNotificationsReducer,
    },
    state: SV.get('storeState'),
};

initializeDBL(options).then(({ store, queue, actions }) => {
    createEntry({
        Container: SbRespCollectionsLayout,
        store,
        query: sbRespCollectionsRoot,
        containerId: 'page',
        queue,
        actions,
    });
});
